import React from 'react';
import { View, StyleSheet, Text } from 'react-native';
import i18n from 'i18n-js';

import { scale } from '@components/frame';
import { font } from '@styles/fonts';
import Svg from '@styles/icons/svg';
import TouchableElement from '@components/common/touchableElement';

import { SearchItem } from '@components/search/components/searchResults';
import { SCREEN_PADDING_HORIZONTAL, TEST_IDS } from '@v2/pages/common/constants/base.constants';

export default ({
  C,
  history = [],
  recentlyViewed = [],
  setSearchValue,
  submit,
  generateImageURL,
  clearHistory,
  clearRecentlyViewed,
  setSelectedNCFile,
  fromHeader,
  onSearch,
  attachMode,
  attachImageId,
}) => {
  return (
    <View testID={TEST_IDS.searchScreen.all.historyContainer} style={{ flex: 1, width: '100%', alignItems: 'center' }}>
      <View style={{ flex: 1, width: '100%' }}>
        <View>
          <View>
            {Boolean(history.length) && (
              <View style={{ paddingHorizontal: scale(SCREEN_PADDING_HORIZONTAL) }}>
                <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignContent: 'center', marginTop: scale(15) }}>
                  <Text style={[font['Headline'], { color: C('Label/Light/Primary') }]}>{i18n.t('Recently Searched')}</Text>
                  <TouchableElement
                    onPress={() => {
                      clearHistory();
                    }}
                  >
                    {({ boxStyle }) => (
                      <View style={[boxStyle]}>
                        <Text style={[font['Body'], { color: C('Link/Light/Primary') }]} numberOfLines={1}>
                          {i18n.t('Clear')}
                        </Text>
                      </View>
                    )}
                  </TouchableElement>
                </View>
                <View
                  style={{
                    width: '100%',
                    backgroundColor: C('Hairline/Light/No trans'),
                    height: StyleSheet.hairlineWidth,
                    marginBottom: scale(8),
                    opacity: history.length ? 1 : 0,
                    marginTop: scale(7),
                  }}
                />
                {history.map((item, index) => (
                  <TouchableElement
                    testID={TEST_IDS.searchScreen.all.historyItem}
                    key={index}
                    onPress={() => {
                      setSearchValue(item);
                      if (fromHeader) {
                        onSearch(item);
                      } else {
                        submit(item);
                      }
                    }}
                    hitSlop={{ top: 0, bottom: 0, left: 0, right: 0 }}
                  >
                    {({ boxStyle }) => (
                      <View key={index} style={[boxStyle, { height: scale(42), flexDirection: 'row', alignItems: 'center' }]}>
                        <Svg icon="history" width={scale(22)} height={scale(20)} color="Label/Light/Tertiary" />
                        <Text style={[font['Subhead 1'], { color: C('Label/Light/Primary'), marginLeft: scale(13) }]} numberOfLines={1}>
                          {item.length > 100 ? item.substring(0, 100) + '...' : item}
                        </Text>
                      </View>
                    )}
                  </TouchableElement>
                ))}
              </View>
            )}
            {Boolean(recentlyViewed.length) && (
              <View>
                <View style={{ paddingHorizontal: scale(SCREEN_PADDING_HORIZONTAL) }}>
                  <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignContent: 'center', marginTop: scale(15) }}>
                    <Text style={[font['Headline'], { color: C('Label/Light/Primary') }]}>{i18n.t('Recently viewed')}</Text>
                    <TouchableElement
                      onPress={() => {
                        clearRecentlyViewed();
                      }}
                    >
                      {({ boxStyle }) => (
                        <View style={[boxStyle]}>
                          <Text style={[font['Body'], { color: C('Link/Light/Primary') }]} numberOfLines={1}>
                            {i18n.t('Clear')}
                          </Text>
                        </View>
                      )}
                    </TouchableElement>
                  </View>
                  <View
                    style={{
                      width: '100%',
                      backgroundColor: C('Hairline/Light/No trans'),
                      height: StyleSheet.hairlineWidth,
                      marginTop: scale(7),
                    }}
                  />
                </View>
                <View>
                  {recentlyViewed.map((item, index) => (
                    <SearchItem {...{ key: index, item, C, generateImageURL, setSelectedNCFile, attachMode, attachImageId }} />
                  ))}
                </View>
              </View>
            )}
          </View>
        </View>
      </View>
    </View>
  );
};
